module.exports = __webpack_public_path__ + "assets/img/43f779a8829f7dfec75dc87d034d6f97.png";